/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_UpdatingInputs */



/**
* | output |
* | --- |
* | "Updating API Key. Please wait..." |
*
* @param {Options_Api_Keys_UpdatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_updating = /** @type {((inputs?: Options_Api_Keys_UpdatingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_UpdatingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise à jour de la clé API. Veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel wird aktualisiert. Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornamento della chiave API. Attendi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновление ключа API. Пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizando clave API. Espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在更新 API 密钥。请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキーを更新しています。お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी अपडेट की जा रही है। कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizando a chave da API. Aguarde...")
	return /** @type {LocalizedString} */ ("Updating API Key. Please wait...")
});